import { InjectionToken } from '@angular/core';

export const GATEWAY_CONFIG = new InjectionToken('CIGNA_ACCESS_BRK_CONFIG');
export const EXT_GATEWAY_CONFIG = new InjectionToken(
  'CIGNA_ACCESS_BRK__EXT_CONFIG',
);

export interface GatewayConfig {
  environmentName: string;
  defaultPath: string;
  getNavigations: string;
  searchClient: string;
  getAlert: string;
  dismissAlert: string;
  checkIpValid: string;
  getProfileUserMatch: string;
  getPartnerId: string;
  getContentHub: string;
  userAgreementUpdate: string;
  getCompensationStatements: string;
  getCompensationStatementsTest: string;
  getFirmsList: string;
  getStatementsList: string;
  getRFPData: string;
  getClientManagerList: string;
  getMessagesList: string;
  addAgency: string;
  getBRProfile: string;
  removeAgency: string;
  getAgencyList: string;
  postAffirm: string;
  getSepWorkQExtUrl: string;
  getComComp: string;
  getBrokerSecurityProfileUrl: string;
  getSpotlight: string;
  getTools: string;
  getBrokerWelcome: string;
  getBusinessAlert: string;
  getRequestForInfo: string;
  getApplicantRfiInternal: string;
  getApplicantRfiExternal: string;
  getViewAllRfiInternal: string;
  getViewAllRfiExternal: string;
  getNotifications: string;
  // ISAM Config:
  clientId: string;
  metadataUri: string;
  authorizeUri: string;
  redirectUri: string;
  homeSecureUri: string;
  cfbApiUrl: string;
  gsgApiUrl: string;
  getMAQE: string;
  getCsbBob: string;
  getCsbCompensation: string;
  getCsbCompensation_v1: string;
  getIfpCompInt: string;
  addAdminRelationship: string;
  getComProDir: string;
  getComCigna: string;
  getComPreDrugList: string;
  getComCfe: string;
  getTimeoutDuration: string;
  getLogoutDuration: string;
  getImpersonatorSwitchUserTimeoutDuration: string;
  getImpersonatorSwitchUserLogoutDuration: string;
  getSolutionsInsights: string;
  getCurrentBusinessData: string;
  verifyUserData: string;
  verifySecurity: string;
  verifyFactorUrl: string;
  getClientSummaryData: string;
  getClientManagerData: string;
  getMaCompensationStatements: string;
  downloadMaCompXls: string;
  getMedicareEligibilityLookup: string;
  getMedicaidEligibilityLookup: string;
  getTokenRequest: string;
  getMaCompPaymentScheduleUrl: string;
  getCompReportsList: string;
  sendPostLoginContactUsEmailNotification: string;
  getSepWorkQIntAdmin: string;
  customer: string;
  publicCpi: string;
  privateCpi: string;
  jwtFrontend: string;
  getRequestNewAccessCodeUrl: string;
  getAccessCodeValidation: string;
  lastLoginDateUpdate: string;
  getRegistrationSubmit: string;
  resetPasswordUrl: string;
  stateTokenUrl: string;
  saveSecurityQuestion: string;
  changePassword: string;
  getSecurityProfileUserData: string;
  getSecurityProfileFactorsData: string;
  addSecurityProfileEmailFactor: string;
  addSecurityProfileMobileFactor: string;
  activateSecurityProfileMobileFactor: string;
  activateSecurityProfileEmailFactor: string;
  resendSecurityProfileMobileFactor: string;
  resendecurityProfileEmailFactor: string;
  verifyPasscode: string;
  getForgotUsernameFindUserData: string;
  getForgotUsernameVerifyUserData: string;
  validateEmail: string;
  getUsernameValidation: string;
  getForgotUsernameRequestUserData: string;
  sendPreLoginContactUsEmailNotification: string;
  accessCdValidateEmail: string;
  profilePreLoad: string;
  profilePreLoadKey: string;
  getOktaExtRedirect: string;
  getKeepAlive: string;
  getAgentViewOktaExtRedirect: string;
  kaplanEmail: string;
  getSnowUrl: string;
  getSgRenewals: string;
  getSgRenewalDownload: string;
  downloadBobCsv: string;
  downloadRfpCsv: string;
}

export interface ExtGatewayConfig {
  getBrokerQuoteMedical: string;
  getIfpMedicalAgency: string;
  getBrokerQuoteDental: string;
  getBrokerQuoteDentalAdmin: string;
  getBrokerQuoteDentalNew: string;
  getIfpMedicalAdmin: string;
  getBrokerQuoteAdvantage2022: string;
  getBrokerQuoteAdvantage2025: string;
  getBrokerQuoteAdvantage: string;
  getBrokerBobCommercial: string;
  getBrokerBobPlans: string;
  getBrokerBobAdvantage: string;
  getBrokerBobBenefits: string;
  getBrokerQuoteBenefits: string;
  getBrokerBobMaApplication: string;
  getMABOBInt: string;
  getMABOBExt: string;
  getMAAppStatusInt: string;
  getMAAppStatusExt: string;
  getIfpAdminUrl: string;
  getSepWorkQIntUrl: string;
  getComReqProposal: string;
  getComTraining: string;
  getComContinueEdu: string;
  getComSolutionInsight: string;
  getCsbQuoteEnroll: string;
  getCsbSalesMarketingMtrl: string;
  getCsbSalesMarketingMtrl_v1: string;
  getCsbIncentives: string;
  getCsbPolicyReporting_v1: string;
  getCsbPolicyReporting: string;
  getCsbAgentInquiry_v1: string;
  getCsbAgentInquiry: string;
  getCsbRecruiting: string;
  getCsbTraining: string;
  getCsbTraining_v1: string;
  getCsbMyCustomers: string;
  getNewCsbBob: string;
  getCsbProductInfo: string;
  getCsbBusinessBuilding: string;
  getCsbBenefits: string;
  getCsbServicingForms: string;
  getCsbToolsExpressApp: string;
  getCsbToolsExpressWay: string;
  getOnDemandExploreContent: string;
  getContinuingEdExploreCatalog: string;
  getContinuingEdExploreCatalogNew: string;
  getIfpMedicalExtAgent: string;
  getIfpCompExt: string;
  getIfpResourceCenterExt: string;
  getUserSession: string;
  getCFELoginLink: string;
  getCFEFederationUrl: string;
  getFindPharmacy2023: string;
  getFindPharmacy2026: string;
  getMaPdpPlans: string;
  getIfpHPS: string;
  getCSBAdam: string;
  getCSBAdamLeadsDashboard: string;
  getCSBAdamNewInsuranceUpdate: string;
  getFindPharmacy2025: string;
  getQuoteEnrollOtherStates: string;
  redirectToNewPortalUrl: string;
  upcomingEvents: string;
}

export enum ApiVersion {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
}

export interface CBParams {
  peid: string;
  index: number;
  sort_key?: string;
  parent_acc_num?: string;
  sort_order?: string;
}

export interface ClientSummaryOptions {
  opportunity_key: string;
}
